/**
 * Parses Query Parameters into an object.
 */

export function hasParams() {
  return window.location.search !== '';
}

export function getParamObject(str?: string | undefined) {
  if (str === undefined) {
    str = window.location.search.replace('?', '');
  }
  const toRet: { [key: string]: string } = {};
  if (!str) return toRet;
  const params = str.split('&');
  params.forEach((param) => {
    const split = param.split('=');
    const key = decodeURIComponent(split[0]);
    const val = decodeURIComponent(split[1]);
    toRet[key] = val;
  });
  return toRet;
}

export function getQueryStringFromArr(arr: { key: string; value: string }[]) {
  let toRet = '';
  if (arr && Array.isArray(arr) && arr.length > 0) {
    arr.forEach((item) => {
      let toAdd = '';
      if (item.key) {
        toAdd += item.key;
      }
      if (item.value) {
        toAdd += '=' + item.value;
      }
      toRet += '&' + toAdd;
    });
    if (toRet.length > 0) {
      // Replace the leading ampersand with a question mark
      toRet = toRet.replace('&', '?');
    }
  }
  return toRet;
}
